export const USD = 0.0035;
export const TOKEN_NAME = "ArtE";

